import { Outlet } from "react-router";
import Header from "../components/layout/Header";

export default function MainLayout() {
  return (
    <div className="w-full h-screen bg-gray-100 font-toyota text-xxs ">
      <Header />
      <Outlet />
    </div>
  );
}
